import { render, staticRenderFns } from "./OrderFans.vue?vue&type=template&id=705ef1bb"
import script from "./OrderFans.vue?vue&type=script&lang=js"
export * from "./OrderFans.vue?vue&type=script&lang=js"
import style0 from "./OrderFans.vue?vue&type=style&index=0&id=705ef1bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports